"use client";

import { useEffect } from "react";
import { useHasActiveUploads } from "@/features/files/upload-manager-store";

/**
 * Impede que o usuario feche a aba no meio de um upload sem aviso. Um upload
 * interrompido deixa o registro em `pending` no servidor ate o job de
 * expiracao recolher — o custo de perder o trabalho e do usuario.
 */
export function UploadLeaveGuard() {
  const hasActiveUploads = useHasActiveUploads();

  useEffect(() => {
    if (!hasActiveUploads) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      // Browsers modernos ignoram a mensagem e exibem texto proprio.
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasActiveUploads]);

  return null;
}
